/**
 * BUNDLE V5 - SISTEMA NUEVO DESDE CERO
 * Enfoque simple y robusto
 */

// ============================================
// COLORES
// ============================================

const COLORS = {
  'Negro': '#000000', 'Beige': '#e8c39e', 'Moca': '#c28787', 'Rosa': '#ffc0cb',
  'Gris': '#d3d3d3', 'Lila': '#b695c0', 'Verde': '#88e788', 'Azul': '#003166',
  'Celeste': '#bceeff', 'Mocca': '#B39B84', 'Crema': '#fef5da', 'Palo Rosa': '#e3aaaa',
  'Arena': '#e9ded0', 'Blanco': '#FFFFFF', 'Rosado': '#ffc0cb', 'Azul Oscuro': '#2d2c55',
  'Azulino': '#003b85', 'Ocre': '#cc7722', 'rojo': '#cf010b', 'Rojo': '#cf010b',
  'rosa': '#ffc0cb', 'Nude': '#ebc8b2', 'Amarillo': '#ffffbf', 'Coral': '#eb636b',
  'Verde agua': '#cceae8', 'Perla': '#f5f7e3', 'Verde Perico': '#008000', 'Fucsia': '#c6186c',
  'Mostaza': '#e7ba54', 'Guinda': '#74091b', 'Verde Militar': '#273b09', 'Azul Acero': '#1e2e4f',
  'Vino': '#640d14', 'Verde Claro': '#b0d7c3', 'Melon': '#fa8072', 'Acero': '#859dbb',
  'Cenizo': '#e2e2e2', 'Camel': '#c08552',
  'Blanco-Copa': 'https://cdn.shopify.com/s/files/1/0841/2489/3461/files/WhatsApp_Image_2025-12-17_at_7.48.46_PM.jpg?v=1766423001',
  'Blanco-Cereza': 'https://cdn.shopify.com/s/files/1/0841/2489/3461/files/WhatsApp_Image_2025-12-17_at_7.49.46_PM.jpg?v=1766422984',
  'Blanco-Perfectly': 'https://cdn.shopify.com/s/files/1/0841/2489/3461/files/WhatsApp_Image_2025-12-17_at_7.47.01_PM.jpg?v=1766423010',
  'Palo Rosa-Cereza': 'https://cdn.shopify.com/s/files/1/0841/2489/3461/files/WhatsApp_Image_2025-12-17_at_7.49.20_PM.jpg?v=1766422994',
  'Palo Rosa-Love': 'https://cdn.shopify.com/s/files/1/0841/2489/3461/files/WhatsApp_Image_2025-12-17_at_7.50.15_PM.jpg?v=1766422970',
  'Negro-Believed': 'https://cdn.shopify.com/s/files/1/0841/2489/3461/files/WhatsApp_Image_2025-12-17_at_7.48.14_PM.jpg?v=1766423010',
  'Camel-Blessed': 'https://cdn.shopify.com/s/files/1/0841/2489/3461/files/WhatsApp_Image_2025-12-22_at_12.11.04_PM.jpg?v=1766423500'
};

function getColorCircle(colorName, size = 20) {
  const color = COLORS[colorName];
  if (!color) return '';
  
  const isImage = color.startsWith('http');
  return `<div style="width:${size}px;height:${size}px;border-radius:50%;border:1px solid #ddd;flex-shrink:0;${isImage ? `background:url('${color}') center/cover` : `background:${color}`}"></div>`;
}

// CSS
const css = document.createElement('style');
css.textContent = `
  .bundle-v5-dropdown {
    position: relative;
    width: 100%;
  }
  .bundle-v5-dropdown__btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: white;
    cursor: pointer;
    width: 100%;
    text-align: left;
  }
  .bundle-v5-dropdown__btn:hover {
    border-color: #999;
  }
  .bundle-v5-dropdown__text {
    flex: 1;
    font-size: 13px;
  }
  .bundle-v5-dropdown__arrow {
    width: 12px;
    height: 8px;
    transition: transform 0.2s;
  }
  .bundle-v5-dropdown.is-open .bundle-v5-dropdown__arrow {
    transform: rotate(180deg);
  }
  .bundle-v5-dropdown__menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin-top: 4px;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    max-height: 250px;
    overflow-y: auto;
    z-index: 1000;
    display: none;
  }
  .bundle-v5-dropdown.is-open .bundle-v5-dropdown__menu {
    display: block;
  }
  .bundle-v5-dropdown__option {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    cursor: pointer;
    border-bottom: 1px solid #f5f5f5;
  }
  .bundle-v5-dropdown__option:hover {
    background: #f8f8f8;
  }
`;
document.head.appendChild(css);

// ============================================
// DROPDOWN COMPONENT
// ============================================

class ColorDropdown {
  constructor(container, options, value, onChange, availabilityMap = {}) {
    this.container = container;
    this.options = options;
    this.value = value;
    this.onChange = onChange;
    this.availabilityMap = availabilityMap; // {option: isAvailable}
    
    this.render();
    this.attach();
  }
  
  render() {
    this.container.innerHTML = `
      <div class="bundle-v5-dropdown">
        <button type="button" class="bundle-v5-dropdown__btn">
          ${getColorCircle(this.value, 20)}
          <span class="bundle-v5-dropdown__text">${this.value}</span>
          <svg class="bundle-v5-dropdown__arrow" viewBox="0 0 12 8">
            <path d="M1 1l5 5 5-5" stroke="currentColor" fill="none" stroke-width="2"/>
          </svg>
        </button>
        <div class="bundle-v5-dropdown__menu">
          ${this.options.map(opt => {
            const isAvailable = this.availabilityMap[opt] !== false;
            const outOfStockClass = !isAvailable ? ' out-of-stock' : '';
            return `
              <div class="bundle-v5-dropdown__option${outOfStockClass}" data-value="${opt}" data-available="${isAvailable}">
                ${getColorCircle(opt, 20)}
                <span>${opt}</span>
              </div>
            `;
          }).join('')}
        </div>
      </div>
    `;
  }
  
  attach() {
    const dropdown = this.container.querySelector('.bundle-v5-dropdown');
    const btn = this.container.querySelector('.bundle-v5-dropdown__btn');
    const options = this.container.querySelectorAll('.bundle-v5-dropdown__option');
    
    console.log(`    🎯 Attaching dropdown with ${options.length} options`);
    
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const wasOpen = dropdown.classList.contains('is-open');
      dropdown.classList.toggle('is-open');
      console.log(`    🖱️ Dropdown clicked, now ${wasOpen ? 'closed' : 'open'}`);
    });
    
    options.forEach((opt, idx) => {
      const val = opt.getAttribute('data-value');
      const isAvailable = opt.getAttribute('data-available') === 'true';
      console.log(`    Option ${idx}: ${val} - Available: ${isAvailable}`);
      
      opt.addEventListener('click', (e) => {
        e.stopPropagation();
        
        console.log(`    🖱️ Option clicked: ${val} (available: ${isAvailable})`);
        
        // No permitir seleccionar opciones sin stock
        if (!isAvailable) {
          console.log(`    ❌ Blocked - out of stock`);
          return;
        }
        
        this.select(val);
        
        // CERRAR el dropdown después de seleccionar
        dropdown.classList.remove('is-open');
        console.log(`    ✅ Dropdown closed after selection`);
      });
    });
    
    this.closeHandler = () => {
      dropdown.classList.remove('is-open');
    };
    document.addEventListener('click', this.closeHandler);
    console.log(`    ✅ Dropdown attached successfully`);
  }
  
  select(val) {
    this.value = val;
    const btn = this.container.querySelector('.bundle-v5-dropdown__btn');
    btn.innerHTML = `
      ${getColorCircle(val, 20)}
      <span class="bundle-v5-dropdown__text">${val}</span>
      <svg class="bundle-v5-dropdown__arrow" viewBox="0 0 12 8">
        <path d="M1 1l5 5 5-5" stroke="currentColor" fill="none" stroke-width="2"/>
      </svg>
    `;
    if (this.onChange) this.onChange(val);
  }
  
  destroy() {
    if (this.closeHandler) {
      document.removeEventListener('click', this.closeHandler);
    }
  }
}

// ============================================
// BUNDLE V5
// ============================================

class BundleV5 {
  constructor(el) {
    this.el = el;
    this.products = new Map(); // slot -> {id, title, image, price, variantId, variants:{Color:X, Talla:Y}}
    this.variants = new Map(); // productId -> array de variants
    this.dropdowns = [];
    this.modalDropdownsConverted = false;
    
    this.config = JSON.parse(el.querySelector('[data-bundle-v5-config]').textContent);
    
    // Buscar elementos DENTRO del bundle (no globalmente)
    this.els = {
      modal: el.querySelector('[data-bundle-v5-modal]'),  // ← Ahora busca en el.
      modalClose: el.querySelector('[data-bundle-v5-close]'),
      count: el.querySelector('[data-bundle-v5-count]'),
      summary: el.querySelector('[data-bundle-v5-summary]'),
      summaryList: el.querySelector('[data-bundle-v5-summary-list]'),
      finalPrice: el.querySelector('[data-bundle-v5-final-price]'),
      addBtn: el.querySelector('[data-bundle-v5-add]')
    };
    
    window._bundleV5 = this;
    
    this.init();
  }
  
  init() {
    console.log('🚀 Bundle V5 iniciando...');
    
    this.loadVariants();
    this.attachListeners();
    
    // Convertir selectores de color ANTES de autoSelect
    setTimeout(() => {
      console.log('🎨 Convirtiendo selectores de color del modal...');
      this.convertModalColorSelects();
      this.modalDropdownsConverted = true;
      
      // Ahora sí autoseleccionar
      this.autoSelect();
    }, 100);
  }
  
  loadVariants() {
    document.querySelectorAll('[data-bundle-v5-variants]').forEach(script => {
      const id = script.getAttribute('data-bundle-v5-variants');
      try {
        this.variants.set(id, JSON.parse(script.textContent));
      } catch (e) {
        console.error('Error loading variants:', e);
      }
    });
    console.log(`✅ Loaded variants for ${this.variants.size} products`);
  }
  
  attachListeners() {
    // Toggle del bundle (abrir/cerrar)
    const toggleBtn = this.el.querySelector('[data-bundle-v5-toggle]');
    const content = this.el.querySelector('[data-bundle-v5-content]');
    
    if (toggleBtn && content) {
      toggleBtn.addEventListener('click', () => {
        const isOpen = content.style.display !== 'none';
        
        if (isOpen) {
          // Cerrar
          content.style.display = 'none';
          toggleBtn.classList.remove('is-open');
        } else {
          // Abrir
          content.style.display = 'block';
          toggleBtn.classList.add('is-open');
        }
      });
      
      console.log('✅ Toggle listener attached');
    }
    
    // EVENT DELEGATION en el bundle
    this.el.addEventListener('click', (e) => {
      const slotBtn = e.target.closest('[data-bundle-v5-slot]');
      if (slotBtn) {
        const slot = parseInt(slotBtn.getAttribute('data-bundle-v5-slot'));
        console.log(`🔘 Opening modal for slot ${slot}`);
        this.openModal(slot);
        return;
      }
      
      const changeBtn = e.target.closest('[data-bundle-v5-change]');
      if (changeBtn) {
        const slot = parseInt(changeBtn.getAttribute('data-bundle-v5-change'));
        console.log(`🔄 Changing slot ${slot}`);
        this.openModal(slot);
        return;
      }
    });
    
    // EVENT DELEGATION en el modal
    this.els.modal.addEventListener('click', (e) => {
      const selectBtn = e.target.closest('[data-bundle-v5-select]');
      if (selectBtn) {
        const productId = selectBtn.getAttribute('data-bundle-v5-select');
        console.log(`✅ Selecting product ${productId}`);
        this.selectProduct(productId);
        return;
      }
      
      const closeBtn = e.target.closest('[data-bundle-v5-close]');
      if (closeBtn) {
        this.closeModal();
        return;
      }
    });
    
    // LISTENER para cambios en selects del modal
    this.els.modal.addEventListener('change', (e) => {
      console.log(`\n🔔 ======== MODAL CHANGE EVENT FIRED ========`);
      console.log(`   Event target:`, e.target);
      console.log(`   Event target tag:`, e.target.tagName);
      console.log(`   Event target value:`, e.target.value);
      
      const select = e.target.closest('[data-bundle-v5-option]');
      if (select) {
        console.log(`   ✅ Found select with data-bundle-v5-option`);
        console.log(`   Select option name:`, select.getAttribute('data-bundle-v5-option'));
        
        const card = select.closest('[data-bundle-v5-product]');
        if (card) {
          const productId = card.getAttribute('data-bundle-v5-product');
          console.log(`   ✅ Found parent card`);
          console.log(`   Product ID from card: ${productId}`);
          console.log(`   Calling updateModalVariant(${productId})...`);
          
          // Actualizar variant (botón y precio)
          this.updateModalVariant(productId);
          
          console.log(`   Calling updateModalOptionAvailability(${productId})...`);
          // Actualizar availability de opciones
          this.updateModalOptionAvailability(productId);
          
          console.log(`======== END MODAL CHANGE EVENT ========\n`);
        } else {
          console.error(`   ❌ Could not find parent card!`);
        }
      } else {
        console.log(`   ❌ Event target is not a select with data-bundle-v5-option`);
      }
    });
    
    // Botón agregar al carrito
    this.els.addBtn.addEventListener('click', () => {
      this.addToCart();
    });
    
    // ESC para cerrar
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.els.modal.style.display === 'flex') {
        this.closeModal();
      }
    });
  }
  
  // NUEVO: Actualizar availability de opciones en el modal
  updateModalOptionAvailability(productId) {
    console.log(`🔄 Updating option availability for product ${productId}`);
    
    const card = this.els.modal.querySelector(`[data-bundle-v5-product="${productId}"]`);
    if (!card) return;
    
    const variants = this.variants.get(productId);
    if (!variants) return;
    
    // Obtener todos los selects
    const selects = card.querySelectorAll('[data-bundle-v5-option]');
    const selectedValues = {};
    
    selects.forEach(s => {
      const optName = s.getAttribute('data-bundle-v5-option');
      selectedValues[optName] = s.value;
    });
    
    console.log(`   Current selections:`, selectedValues);
    
    // Para cada select
    selects.forEach(select => {
      const optionName = select.getAttribute('data-bundle-v5-option');
      const isColor = optionName.toLowerCase().includes('color');
      const isConverted = select.hasAttribute('data-dropdown-converted');
      const options = Array.from(select.options).map(o => o.value);
      
      console.log(`   Updating ${optionName} (color: ${isColor}, converted: ${isConverted})...`);
      
      // Calcular availability para cada opción
      const availabilityMap = {};
      
      // CRÍTICO: Crear mapeo correcto de opciones usando valores reales
      const optionNames = Object.keys(selectedValues);
      const optionMapping = {};
      
      // Para cada nombre de opción, buscar en qué option1/2/3 está su valor
      optionNames.forEach(optName => {
        const optValue = selectedValues[optName];
        
        // Buscar en variants dónde aparece este valor
        for (let i = 1; i <= 3; i++) {
          const optKey = `option${i}`;
          const hasValue = variants.some(v => v[optKey] === optValue);
          
          if (hasValue && !Object.values(optionMapping).includes(i)) {
            optionMapping[optName] = i;
            break;
          }
        }
      });
      
      console.log(`     Option mapping:`, optionMapping);
      console.log(`     Current selections:`, selectedValues);
      
      options.forEach(optValue => {
        // Crear combinación temporal
        const testCombination = {...selectedValues};
        testCombination[optionName] = optValue;
        
        console.log(`     Testing: ${optionName} = ${optValue}`);
        console.log(`       Full combination:`, testCombination);
        
        // Buscar variant que coincida usando mapeo correcto
        const matchingVariants = variants.filter(v => {
          const allOptionsMatch = Object.entries(testCombination).every(([optName, optVal]) => {
            const optIndex = optionMapping[optName];
            const matches = v[`option${optIndex}`] === optVal;
            
            if (!matches) {
              console.log(`         Mismatch: ${optName} (option${optIndex}): "${optVal}" !== "${v[`option${optIndex}`]}"`);
            }
            
            return matches;
          });
          return allOptionsMatch;
        });
        
        console.log(`       Matching variants:`, matchingVariants.length);
        
        const hasAvailable = matchingVariants.some(v => v.available);
        
        availabilityMap[optValue] = hasAvailable;
        console.log(`     ${optValue}: ${hasAvailable ? '✅ Available' : '❌ Out of stock'}`);
      });
      
      // SI ES DROPDOWN CONVERTIDO: Recrear
      if (isConverted && isColor) {
        console.log(`     🔄 Recreating color dropdown...`);
        
        const container = select.nextElementSibling;
        if (container && container.classList.contains('modal-color-dropdown-container')) {
          // Limpiar contenedor
          container.innerHTML = '';
          
          // Recrear dropdown con nuevo availabilityMap
          new ColorDropdown(container, options, select.value, (newVal) => {
            // VALIDAR que el select pertenece al producto correcto
            const selectCard = select.closest('[data-bundle-v5-product]');
            const selectProductId = selectCard?.getAttribute('data-bundle-v5-product');
            
            if (selectProductId === productId) {
              console.log(`     ✅ Dropdown callback (update) fired for correct product: ${productId}`);
              select.value = newVal;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              console.error(`     ❌ DROPDOWN UPDATE ERROR: Expected product ${productId}, but select belongs to ${selectProductId}`);
            }
          }, availabilityMap);
          
          console.log(`     ✅ Dropdown recreated`);
        }
      } 
      // SI ES SELECT NORMAL: Actualizar opciones
      else {
        options.forEach(optValue => {
          const hasAvailable = availabilityMap[optValue];
          const option = Array.from(select.options).find(o => o.value === optValue);
          
          if (option) {
            if (!hasAvailable) {
              option.disabled = true;
              if (!option.textContent.includes('(Agotado)')) {
                option.textContent = optValue + ' (Agotado)';
              }
            } else {
              option.disabled = false;
              option.textContent = optValue;
            }
          }
        });
        
        console.log(`     ✅ Select updated`);
      }
    });
  }
  
  // NUEVO: Actualizar variant en el modal cuando cambian los selects
  updateModalVariant(productId) {
    console.log(`🔍 Updating modal variant for product ${productId}`);
    
    const card = this.els.modal.querySelector(`[data-bundle-v5-product="${productId}"]`);
    if (!card) return;
    
    // Obtener valores de todos los selects
    const selects = card.querySelectorAll('[data-bundle-v5-option]');
    const selectedOptions = Array.from(selects).map(s => s.value);
    
    console.log(`   Selected options:`, selectedOptions);
    
    // Buscar variant
    const variants = this.variants.get(productId);
    if (!variants) {
      console.warn(`   No variants data for product ${productId}`);
      return;
    }
    
    const match = variants.find(v => 
      selectedOptions.every((val, idx) => v[`option${idx + 1}`] === val)
    );
    
    if (match) {
      console.log(`   ✅ Found variant: ${match.id}, available: ${match.available}`);
      
      // Actualizar botón
      const btn = card.querySelector('[data-bundle-v5-select]');
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? 'Seleccionar' : 'Agotado';
        btn.setAttribute('data-variant-id', match.id);
        btn.setAttribute('data-price', match.price);
      }
      
      // Actualizar precio mostrado
      const priceEl = card.querySelector('[data-modal-price]');
      if (priceEl) {
        priceEl.textContent = this.money(match.price);
      }
    } else {
      console.warn(`   ❌ Variant not found for options:`, selectedOptions);
      
      // Deshabilitar botón
      const btn = card.querySelector('[data-bundle-v5-select]');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'No disponible';
      }
    }
  }
  
  autoSelect() {
    console.log('🔄 Auto-selecting first product...');
    const firstProduct = this.els.modal.querySelector('[data-bundle-v5-product]');
    if (firstProduct) {
      const productId = firstProduct.getAttribute('data-bundle-v5-product');
      
      // Actualizar availability antes de seleccionar
      this.updateModalOptionAvailability(productId);
      
      // VERIFICAR: ¿La primera variante tiene stock?
      const variants = this.variants.get(productId);
      if (variants && variants.length > 0) {
        const firstVariant = variants[0];
        
        console.log(`   Checking first variant:`, {
          id: firstVariant.id,
          option1: firstVariant.option1,
          option2: firstVariant.option2,
          available: firstVariant.available
        });
        
        if (!firstVariant.available) {
          console.warn(`   ⚠️ First variant not available, searching for available variant...`);
          
          // Buscar la primera variante disponible
          const availableVariant = variants.find(v => v.available);
          
          if (availableVariant) {
            console.log(`   ✅ Found available variant:`, {
              id: availableVariant.id,
              option1: availableVariant.option1,
              option2: availableVariant.option2
            });
            
            // Actualizar los selects del modal para que coincidan con esta variante
            const card = firstProduct;
            const selects = card.querySelectorAll('[data-bundle-v5-option]');
            
            console.log(`   Updating ${selects.length} selects for first product only (ID: ${productId})`);
            
            selects.forEach((select, idx) => {
              // Verificar que este select pertenece a este card específico
              const parentCard = select.closest('[data-bundle-v5-product]');
              if (parentCard && parentCard.getAttribute('data-bundle-v5-product') === productId) {
                const optionValue = availableVariant[`option${idx + 1}`];
                if (optionValue) {
                  console.log(`   Setting select ${idx + 1} to: ${optionValue} (confirmed card match)`);
                  select.value = optionValue;
                } else {
                  console.warn(`   No value for option${idx + 1}`);
                }
              } else {
                console.error(`   ❌ SELECT BELONGS TO DIFFERENT CARD! This should not happen.`);
              }
            });
            
            // Actualizar el botón también
            const btn = card.querySelector('[data-bundle-v5-select]');
            if (btn) {
              btn.setAttribute('data-variant-id', availableVariant.id);
              btn.setAttribute('data-price', availableVariant.price);
            }
          } else {
            console.error(`   ❌ No available variants found for this product!`);
            alert('El primer producto no tiene stock disponible. Por favor selecciona otro producto.');
            return;
          }
        }
      }
      
      this.currentSlot = 1;
      this.selectProduct(productId, true); // ← isAutoSelect = true
    }
  }
  
  openModal(slot) {
    this.currentSlot = slot;
    
    console.log(`\n📂 OPENING MODAL FOR SLOT ${slot}`);
    
    // Mostrar colección correcta
    this.els.modal.querySelectorAll('[data-bundle-v5-collection]').forEach(col => {
      col.style.display = col.getAttribute('data-bundle-v5-collection') === slot.toString() ? 'block' : 'none';
    });
    
    // Convertir selectores de color a dropdowns si no se ha hecho
    if (!this.modalDropdownsConverted) {
      console.log('🎨 Convirtiendo selectores de color del modal (desde openModal)...');
      this.convertModalColorSelects();
      this.modalDropdownsConverted = true;
    }
    
    // Actualizar availability de todas las opciones en cards visibles
    const visibleCards = this.els.modal.querySelectorAll(`[data-bundle-v5-collection="${slot}"] [data-bundle-v5-product]`);
    visibleCards.forEach(card => {
      const productId = card.getAttribute('data-bundle-v5-product');
      this.updateModalOptionAvailability(productId);
    });
    
    this.els.modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
  
  convertModalColorSelects() {
    const cards = this.els.modal.querySelectorAll('[data-bundle-v5-product]');
    let converted = 0;
    
    console.log(`🎨 Starting conversion of ${cards.length} product cards...`);
    
    cards.forEach(card => {
      const productId = card.getAttribute('data-bundle-v5-product');
      const selects = card.querySelectorAll('[data-bundle-v5-option]');
      
      console.log(`  📦 Product ${productId}: ${selects.length} selects found`);
      
      selects.forEach(select => {
        const optionName = select.getAttribute('data-bundle-v5-option');
        const isColor = optionName.toLowerCase().includes('color');
        
        if (isColor && !select.hasAttribute('data-dropdown-converted')) {
          console.log(`    🎨 Converting COLOR select: ${optionName}`);
          
          const options = Array.from(select.options).map(o => o.value);
          const currentValue = select.value;
          
          // Crear mapa de disponibilidad para cada opción de color
          const availabilityMap = {};
          const variants = this.variants.get(productId);
          
          if (variants) {
            console.log(`      Variants found: ${variants.length}`);
            
            // NOTA: En la carga inicial, calculamos si EXISTE algún variant con este color disponible
            // Esto es menos estricto que verificar la combinación completa, pero es correcto
            // porque el usuario aún no ha seleccionado todas las opciones
            
            // Obtener todos los selects para saber qué opciones hay
            const allSelects = card.querySelectorAll('[data-bundle-v5-option]');
            const currentSelections = {};
            
            allSelects.forEach(s => {
              const name = s.getAttribute('data-bundle-v5-option');
              currentSelections[name] = s.value;
            });
            
            console.log(`      Current selections:`, currentSelections);
            
            // Crear mapeo correcto
            const optionNames = Object.keys(currentSelections);
            const optionMapping = {};
            
            optionNames.forEach(name => {
              const value = currentSelections[name];
              for (let i = 1; i <= 3; i++) {
                if (variants.some(v => v[`option${i}`] === value)) {
                  if (!Object.values(optionMapping).includes(i)) {
                    optionMapping[name] = i;
                    break;
                  }
                }
              }
            });
            
            console.log(`      Option mapping:`, optionMapping);
            
            options.forEach(colorValue => {
              // Crear combinación de prueba
              const testCombination = {...currentSelections};
              testCombination[optionName] = colorValue;
              
              // Buscar si existe variant disponible con esta combinación
              const hasAvailable = variants.some(v => {
                const allMatch = Object.entries(testCombination).every(([name, value]) => {
                  const optIndex = optionMapping[name];
                  return v[`option${optIndex}`] === value;
                });
                return allMatch && v.available;
              });
              
              availabilityMap[colorValue] = hasAvailable;
              console.log(`      ${colorValue}: ${hasAvailable ? '✅ Available' : '❌ Out of stock'}`);
            });
          } else {
            console.warn(`      ⚠️ No variants data found`);
          }
          
          // Ocultar el select
          select.style.display = 'none';
          select.setAttribute('data-dropdown-converted', 'true');
          
          // Crear contenedor para dropdown
          const container = document.createElement('div');
          container.className = 'modal-color-dropdown-container';
          select.parentNode.insertBefore(container, select.nextSibling);
          
          // Crear dropdown con availability map
          new ColorDropdown(container, options, currentValue, (newVal) => {
            // VALIDAR: Asegurar que estamos modificando el select correcto
            const selectCard = select.closest('[data-bundle-v5-product]');
            const expectedProductId = selectCard?.getAttribute('data-bundle-v5-product');
            
            if (expectedProductId === productId) {
              console.log(`    ✅ Dropdown callback fired for correct product: ${productId}`);
              select.value = newVal;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              console.error(`    ❌ DROPDOWN CALLBACK ERROR: Expected product ${productId}, but select belongs to ${expectedProductId}`);
            }
          }, availabilityMap);
          
          converted++;
        }
      });
    });
    
    console.log(`✅ Convertidos ${converted} selectores de color en modal`);
  }
  
  closeModal() {
    console.log(`🚪 Closing modal - resetting all selects...`);
    
    // RESETEAR TODOS los selects del modal a su primera opción
    // Esto asegura que la próxima vez que se abra, todos empiecen frescos
    const allCards = this.els.modal.querySelectorAll('[data-bundle-v5-product]');
    
    allCards.forEach(card => {
      const productId = card.getAttribute('data-bundle-v5-product');
      const selects = card.querySelectorAll('[data-bundle-v5-option]');
      
      selects.forEach(select => {
        if (select.options.length > 0) {
          const firstValue = select.options[0].value;
          const optionName = select.getAttribute('data-bundle-v5-option');
          
          if (select.value !== firstValue) {
            console.log(`   Resetting product ${productId} ${optionName}: "${select.value}" → "${firstValue}"`);
            select.value = firstValue;
            
            // Si es un dropdown convertido, también resetear el visual
            const isConverted = select.hasAttribute('data-dropdown-converted');
            if (isConverted) {
              const dropdownContainer = select.nextElementSibling;
              if (dropdownContainer && dropdownContainer.classList.contains('modal-color-dropdown-container')) {
                const dropdownBtn = dropdownContainer.querySelector('.bundle-v5-dropdown__btn .bundle-v5-dropdown__text');
                if (dropdownBtn) {
                  dropdownBtn.textContent = firstValue;
                }
              }
            }
          }
        }
      });
    });
    
    this.els.modal.style.display = 'none';
    document.body.style.overflow = '';
    
    console.log(`✅ Modal closed and reset`);
  }
  
  // Helper: Obtener el valor real de una opción (dropdown o select)
  getOptionValue(card, optionName) {
    const select = card.querySelector(`[data-bundle-v5-option="${optionName}"]`);
    if (!select) {
      console.warn(`    ⚠️ Select not found for ${optionName}`);
      return null;
    }
    
    // Si el select fue convertido a dropdown
    if (select.hasAttribute('data-dropdown-converted') && select.style.display === 'none') {
      // Buscar el dropdown container
      const dropdownContainer = select.nextElementSibling;
      
      if (dropdownContainer && dropdownContainer.classList.contains('modal-color-dropdown-container')) {
        // Leer del botón del dropdown (más confiable que buscar en array)
        const dropdownBtn = dropdownContainer.querySelector('.bundle-v5-dropdown__btn .bundle-v5-dropdown__text');
        
        if (dropdownBtn) {
          const value = dropdownBtn.textContent.trim();
          console.log(`      ✅ Reading from dropdown button: ${optionName} = "${value}"`);
          return value;
        } else {
          console.warn(`      ⚠️ Dropdown button not found, falling back to select`);
        }
      }
    }
    
    // Fallback: leer del select
    const value = select.value;
    console.log(`      ✅ Reading from select: ${optionName} = "${value}"`);
    return value;
  }
  
  selectProduct(productId, isAutoSelect = false) {
    console.log(`\n🎯 SELECT PRODUCT - INICIO`);
    console.log(`   Product ID: ${productId}`);
    console.log(`   Current Slot: ${this.currentSlot}`);
    console.log(`   Is Auto Select: ${isAutoSelect}`);
    
    const card = this.els.modal.querySelector(`[data-bundle-v5-product="${productId}"]`);
    if (!card) {
      console.error(`   ❌ Card not found for product ${productId}`);
      return;
    }
    
    // Leer datos del botón
    const btn = card.querySelector('[data-bundle-v5-select]');
    const product = {
      id: productId,
      title: btn.getAttribute('data-title'),
      image: btn.getAttribute('data-image'),
      price: parseInt(btn.getAttribute('data-price')),
      variantId: btn.getAttribute('data-variant-id'),
      url: btn.getAttribute('data-url'),
      variants: {}
    };
    
    console.log(`   📦 Initial data from button:`);
    console.log(`      Title: ${product.title}`);
    console.log(`      VariantId (from button): ${product.variantId}`);
    console.log(`      Price (from button): ${product.price}`);
    
    // NO leer variantes de los selects del modal porque pueden tener valores contaminados
    // En su lugar, SIEMPRE obtener las variantes del variant ID del botón
    console.log(`   🔍 Getting variants from button's variant ID...`);
    
    const variants = this.variants.get(productId);
    if (variants) {
      const matchedVariant = variants.find(v => v.id.toString() === product.variantId.toString());
      
      if (matchedVariant) {
        console.log(`   ✅ Found variant in Shopify data:`, {
          id: matchedVariant.id,
          option1: matchedVariant.option1,
          option2: matchedVariant.option2,
          option3: matchedVariant.option3
        });
        
        // Leer los nombres de las opciones desde los selects
        const selects = card.querySelectorAll('[data-bundle-v5-option]');
        const optionNames = Array.from(selects).map(s => s.getAttribute('data-bundle-v5-option'));
        
        console.log(`   📋 Found ${selects.length} selects in modal card`);
        console.log(`   📋 Option names from selects:`, optionNames);
        
        if (optionNames.length === 0) {
          console.error(`   ❌ No option names found! Card may not have selects.`);
          console.error(`   Card:`, card);
          return;
        }
        
        // CRÍTICO: Crear mapeo correcto de opciones
        // Necesitamos saber qué nombre de opción corresponde a qué option1/2/3
        const optionMapping = {}; // {Color: 1, TAMAÑO: 2}
        
        // Para cada nombre de opción, buscar en qué option1/2/3 está
        optionNames.forEach(optionName => {
          // Buscar en qué option1/2/3 aparece este nombre
          for (let i = 1; i <= 3; i++) {
            const optKey = `option${i}`;
            const optValue = matchedVariant[optKey];
            
            // Verificar si algún variant tiene un valor en este optionX
            if (optValue && !Object.values(optionMapping).includes(i)) {
              optionMapping[optionName] = i;
              console.log(`   Mapped: ${optionName} → option${i}`);
              break;
            }
          }
        });
        
        console.log(`   ✅ Option mapping:`, optionMapping);
        
        // Construir product.variants usando el mapeo correcto
        optionNames.forEach(optionName => {
          const optionIndex = optionMapping[optionName];
          if (optionIndex) {
            const optionValue = matchedVariant[`option${optionIndex}`];
            if (optionValue) {
              product.variants[optionName] = optionValue;
              console.log(`   Setting ${optionName} (option${optionIndex}) = ${optionValue}`);
            }
          }
        });
        
        console.log(`   ✅ product.variants from variant ID:`, product.variants);
      } else {
        console.error(`   ❌ Variant ID ${product.variantId} not found in Shopify data!`);
      }
    } else {
      console.error(`   ❌ No variants data for product ${productId}`);
    }
    
    console.log(`   💾 Final product to save:`);
    console.log(`      VariantId: ${product.variantId}`);
    console.log(`      Price: ${product.price}`);
    console.log(`      Variants:`, product.variants);
    
    // VALIDACIÓN DE STOCK: Verificar que el variant esté disponible
    // Ya tenemos variants del código anterior, no redeclarar
    if (variants) {
      const selectedVariant = variants.find(v => v.id.toString() === product.variantId.toString());
      
      if (selectedVariant) {
        console.log(`   📊 Stock check: available = ${selectedVariant.available}`);
        
        if (!selectedVariant.available) {
          console.error(`   ❌ VARIANT ${product.variantId} NOT AVAILABLE!`);
          alert(`Este producto no está disponible en la combinación seleccionada. Por favor elige otra opción.`);
          
          // No cerrar el modal, permitir que el usuario seleccione otra opción
          return;
        }
        
        console.log(`   ✅ Variant has stock - proceeding`);
      }
    }
    
    console.log(`   Saving to Map at slot ${this.currentSlot}`);
    
    this.products.set(this.currentSlot, product);
    
    // Verificar que se guardó
    const saved = this.products.get(this.currentSlot);
    console.log(`   ✔️ Verification - saved variants:`, saved?.variants);
    console.log(`   ✔️ Verification - saved variantId:`, saved?.variantId);
    
    this.closeModal();
    this.render();
    
    console.log(`🎯 SELECT PRODUCT - COMPLETADO\n`);
  }
  
  render() {
    console.log('🎨 Rendering...');
    
    // Limpiar dropdowns
    this.dropdowns.forEach(d => d.destroy());
    this.dropdowns = [];
    
    // Renderizar cada slot
    for (let slot = 1; slot <= this.config.slots; slot++) {
      const container = this.el.querySelector(`[data-bundle-v5-preview="${slot}"]`);
      const slotBtn = this.el.querySelector(`[data-bundle-v5-slot="${slot}"]`);
      
      if (!container || !slotBtn) continue;
      
      if (this.products.has(slot)) {
        const p = this.products.get(slot);
        
        slotBtn.style.display = 'none';
        container.style.display = 'block';
        
        // HTML de variantes
        let varHtml = '';
        Object.entries(p.variants).forEach(([name, val]) => {
          const isColor = name.toLowerCase().includes('color');
          
          if (isColor) {
            varHtml += `
              <div class="selected-product-card__variant-group">
                <label class="selected-product-card__variant-label">${name}</label>
                <div class="selected-product-card__variant-control" data-dropdown-v5="${slot}-${name}" data-slot="${slot}" data-option="${name}" data-value="${val}" data-product="${p.id}"></div>
              </div>
            `;
          } else {
            varHtml += `
              <div class="selected-product-card__variant-group">
                <label class="selected-product-card__variant-label">${name}</label>
                <select class="bundle-v5__variant-select selected-product-card__variant-control" data-select-v5="${slot}-${name}" data-slot="${slot}" data-option="${name}" data-product="${p.id}">
                  <option value="${val}">${val}</option>
                </select>
              </div>
            `;
          }
        });
        
        container.innerHTML = `
          <div class="selected-product-card">
            <div class="selected-product-card__image">
              <img src="${p.image}" alt="${p.title}">
            </div>
            <div class="selected-product-card__info">
              <a href="${p.url}" target="_blank" class="selected-product-card__title" style="text-decoration: none; color: inherit; cursor: pointer;">
                ${p.title}
              </a>
              <div class="selected-product-card__variants">${varHtml}</div>
              <div class="selected-product-card__price" data-price-v5="${slot}">${this.money(p.price)}</div>
            </div>
            <button class="selected-product-card__change" data-bundle-v5-change="${slot}" type="button">×</button>
          </div>
        `;
        
        // Crear dropdowns y selects con listeners
        requestAnimationFrame(() => {
          this.attachVariantControls(slot, p);
        });
        
      } else {
        slotBtn.style.display = '';
        container.style.display = 'none';
      }
    }
    
    // Actualizar UI
    this.updateUI();
  }
  
  attachVariantControls(slot, product) {
    console.log(`🔧 Attaching controls for slot ${slot}`);
    
    // Dropdowns de color
    Object.entries(product.variants).forEach(([name, val]) => {
      const isColor = name.toLowerCase().includes('color');
      
      if (isColor) {
        // Buscar el dropdown dentro del preview específico del slot
        const slotPreview = this.el.querySelector(`[data-bundle-v5-preview="${slot}"]`);
        if (!slotPreview) {
          console.warn(`  ⚠️ Slot preview not found for slot ${slot}`);
          return;
        }
        
        const dropContainer = slotPreview.querySelector(`[data-dropdown-v5="${slot}-${name}"]`);
        if (!dropContainer) {
          console.warn(`  ⚠️ Dropdown container not found: ${slot}-${name}`);
          return;
        }
        
        console.log(`  Creating dropdown for ${name}`);
        
        // Obtener opciones del modal
        const modalCard = this.els.modal.querySelector(`[data-bundle-v5-product="${product.id}"]`);
        const modalSelect = modalCard?.querySelector(`[data-bundle-v5-option="${name}"]`);
        const options = modalSelect ? Array.from(modalSelect.options).map(o => o.value) : [];
        
        if (options.length > 0) {
          // Crear mapa de disponibilidad
          const availabilityMap = {};
          const variants = this.variants.get(product.id);
          
          if (variants) {
            // Crear mapeo correcto buscando en variants
            const optionNames = Object.keys(product.variants);
            const optionMapping = {};
            
            optionNames.forEach(optName => {
              const optVal = product.variants[optName];
              
              // Buscar en qué option1/2/3 está este valor
              for (let i = 1; i <= 3; i++) {
                const optKey = `option${i}`;
                const hasValue = variants.some(v => v[optKey] === optVal);
                
                if (hasValue && !Object.values(optionMapping).includes(i)) {
                  optionMapping[optName] = i;
                  break;
                }
              }
            });
            
            console.log(`       Option mapping:`, optionMapping);
            
            options.forEach(colorValue => {
              // Crear combinación temporal con esta opción
              const tempVariants = {...product.variants};
              tempVariants[name] = colorValue;
              
              // Ver si existe variant disponible con esta combinación
              const hasAvailable = variants.some(v => {
                return Object.entries(tempVariants).every(([optName, optVal]) => {
                  const optIndex = optionMapping[optName];
                  return v[`option${optIndex}`] === optVal;
                }) && v.available;
              });
              
              availabilityMap[colorValue] = hasAvailable;
              console.log(`       ${colorValue}: ${hasAvailable ? '✅' : '❌'}`);
            });
          }
          
          const dropdown = new ColorDropdown(dropContainer, options, val, (newVal) => {
            console.log(`\n🎨 DROPDOWN CALLBACK FIRED!`);
            console.log(`   Slot: ${slot}, Option: ${name}, Value: ${newVal}`);
            
            // Verificar que el producto existe en Map ANTES de actualizar
            const currentProduct = this.products.get(slot);
            if (!currentProduct) {
              console.error('   ❌ Product not in Map!');
              return;
            }
            
            console.log(`   Current product in Map:`, currentProduct);
            
            // Llamar a updateVariant
            this.updateVariant(slot, name, newVal);
            
            // VERIFICAR que se actualizó
            setTimeout(() => {
              const updated = this.products.get(slot);
              console.log(`   ✔️ After update - VariantId in Map: ${updated?.variantId}`);
            }, 100);
          }, availabilityMap);
          
          this.dropdowns.push(dropdown);
          console.log(`  ✅ Dropdown created`);
        } else {
          console.warn(`  ⚠️ No options for ${name}`);
        }
      } else {
        // Selects normales  
        // Buscar el select dentro del preview específico del slot
        const slotPreview = this.el.querySelector(`[data-bundle-v5-preview="${slot}"]`);
        if (!slotPreview) {
          console.warn(`  ⚠️ Slot preview not found for slot ${slot}`);
          return;
        }
        
        const select = slotPreview.querySelector(`[data-select-v5="${slot}-${name}"]`);
        if (!select) {
          console.warn(`  ⚠️ Select not found: ${slot}-${name}`);
          return;
        }
        
        console.log(`  Creating select for ${name}`);
        
        // Obtener opciones y disponibilidad
        const modalCard = this.els.modal.querySelector(`[data-bundle-v5-product="${product.id}"]`);
        const modalSelect = modalCard?.querySelector(`[data-bundle-v5-option="${name}"]`);
        
        if (modalSelect) {
          const variants = this.variants.get(product.id);
          const options = Array.from(modalSelect.options).map(o => o.value);
          
          // Limpiar select
          select.innerHTML = '';
          
          if (variants) {
            console.log(`    📋 Creating options for ${name}:`);
            console.log(`       Product variants:`, product.variants);
            
            // Crear mapeo correcto de opciones buscando en variants
            const optionNames = Object.keys(product.variants);
            const optionMapping = {};
            
            optionNames.forEach(optName => {
              const optVal = product.variants[optName];
              
              // Buscar en qué option1/2/3 está este valor
              for (let i = 1; i <= 3; i++) {
                const optKey = `option${i}`;
                const hasValue = variants.some(v => v[optKey] === optVal);
                
                if (hasValue && !Object.values(optionMapping).includes(i)) {
                  optionMapping[optName] = i;
                  break;
                }
              }
            });
            
            console.log(`       Option names:`, optionNames);
            console.log(`       Option mapping:`, optionMapping);
            
            options.forEach(optionValue => {
              // Crear combinación temporal con esta opción
              const tempVariants = {...product.variants};
              tempVariants[name] = optionValue;
              
              console.log(`       Checking ${optionValue}:`);
              console.log(`         Temp variants:`, tempVariants);
              
              // Ver si existe variant disponible con esta combinación
              const matchingVariants = variants.filter(v => {
                return Object.entries(tempVariants).every(([optName, optVal]) => {
                  const optIndex = optionMapping[optName];
                  const matches = v[`option${optIndex}`] === optVal;
                  if (!matches) {
                    console.log(`           Mismatch: ${optName} (option${optIndex}): "${optVal}" !== "${v[`option${optIndex}`]}"`);
                  }
                  return matches;
                });
              });
              
              console.log(`         Matching variants:`, matchingVariants);
              
              const hasAvailable = matchingVariants.some(v => v.available);
              
              console.log(`         Has available: ${hasAvailable}`);
              
              const option = document.createElement('option');
              option.value = optionValue;
              
              if (!hasAvailable) {
                option.disabled = true;
                option.textContent = optionValue + ' (Agotado)';
                console.log(`         ❌ Disabled: ${optionValue} (Agotado)`);
              } else {
                option.textContent = optionValue;
                console.log(`         ✅ Available: ${optionValue}`);
              }
              
              select.appendChild(option);
            });
          } else {
            console.warn(`    ⚠️ No variants data, copying from modal`);
            // Si no hay variants data, copiar del modal
            select.innerHTML = modalSelect.innerHTML;
          }
          
          // Primero establecer el valor antes de clonar
          select.value = val;
          console.log(`         🎯 Set select value to: ${val}`);
        }
        
        // REMOVER listeners anteriores clonando el elemento
        const newSelect = select.cloneNode(true);
        
        // CRÍTICO: Volver a establecer el valor después de clonar
        newSelect.value = val;
        console.log(`         ✅ Confirmed select value: ${newSelect.value}`);
        
        select.parentNode.replaceChild(newSelect, select);
        
        newSelect.addEventListener('change', (e) => {
          console.log(`\n📝 SELECT CHANGE FIRED!`);
          console.log(`   Slot: ${slot}, Option: ${name}, Value: ${e.target.value}`);
          
          // Verificar que el producto existe
          const currentProduct = this.products.get(slot);
          if (!currentProduct) {
            console.error('   ❌ Product not in Map!');
            return;
          }
          
          console.log(`   Current product in Map:`, currentProduct);
          
          // Llamar a updateVariant
          this.updateVariant(slot, name, e.target.value);
          
          // VERIFICAR que se actualizó
          setTimeout(() => {
            const updated = this.products.get(slot);
            console.log(`   ✔️ After update - VariantId in Map: ${updated?.variantId}`);
          }, 100);
        });
        
        console.log(`  ✅ Select listener attached`);
      }
    });
  }
  
  updateVariant(slot, optionName, newValue) {
    console.log(`\n═══════════════════════════════════════`);
    console.log(`🔄 UPDATE VARIANT - INICIO`);
    console.log(`   Slot: ${slot}`);
    console.log(`   Option: ${optionName}`);
    console.log(`   New Value: ${newValue}`);
    console.log(`═══════════════════════════════════════`);
    
    // PASO 1: Obtener producto del Map
    const oldProduct = this.products.get(slot);
    if (!oldProduct) {
      console.error('❌ PASO 1 FAILED: Product not in Map');
      return;
    }
    console.log('✅ PASO 1: Product found in Map');
    console.log('   Old variants:', oldProduct.variants);
    console.log('   Old variantId:', oldProduct.variantId);
    
    // PASO 2: Crear copia profunda
    const product = JSON.parse(JSON.stringify(oldProduct));
    console.log('✅ PASO 2: Deep copy created');
    
    // PASO 3: Actualizar variante
    product.variants[optionName] = newValue;
    console.log('✅ PASO 3: Variant updated');
    console.log('   New variants:', product.variants);
    
    // PASO 4: Buscar nuevo variant
    const variants = this.variants.get(product.id);
    if (!variants) {
      console.error('❌ PASO 4 FAILED: No variants data for product', product.id);
      return;
    }
    console.log('✅ PASO 4: Variants data found');
    console.log('   Total variants available:', variants.length);
    
    // PASO 4.5: Obtener el mapeo correcto de opciones
    // Necesitamos saber qué opción (Color, TAMAÑO, etc) corresponde a qué option1, option2, etc
    const firstVariant = variants[0];
    console.log('   First variant sample:', {
      option1: firstVariant.option1,
      option2: firstVariant.option2,
      option3: firstVariant.option3
    });
    
    const optionMapping = {}; // {Color: 1, TAMAÑO: 2}
    
    // Obtener los nombres de opciones desde el producto
    const optionNames = Object.keys(product.variants);
    console.log('   Option names:', optionNames);
    
    // Para cada nombre de opción, encontrar su índice REAL buscando el valor en los variants
    optionNames.forEach(optionName => {
      const optionValue = product.variants[optionName];
      
      // Buscar en qué option1/2/3 aparece este valor
      for (let i = 1; i <= 3; i++) {
        const optKey = `option${i}`;
        const hasValue = variants.some(v => v[optKey] === optionValue);
        
        if (hasValue && !Object.values(optionMapping).includes(i)) {
          optionMapping[optionName] = i;
          console.log(`   Mapped: ${optionName} → option${i} (found value "${optionValue}")`);
          break;
        }
      }
    });
    
    console.log('✅ PASO 4.5: Option mapping created:', optionMapping);
    
    // PASO 5: Match variant usando el mapeo correcto
    console.log('   Looking for combination:');
    Object.entries(product.variants).forEach(([name, value]) => {
      console.log(`     ${name} (option${optionMapping[name]}): ${value}`);
    });
    
    const match = variants.find(v => {
      // Verificar que TODAS las opciones coincidan usando el mapeo correcto
      const allMatch = Object.entries(product.variants).every(([name, value]) => {
        const optionIndex = optionMapping[name];
        const vKey = `option${optionIndex}`;
        const vVal = v[vKey];
        const isMatch = vVal === value;
        
        if (!isMatch) {
          console.log(`     ❌ Mismatch: ${name} (${vKey}): "${value}" !== "${vVal}"`);
        }
        
        return isMatch;
      });
      
      if (allMatch) {
        console.log(`     ✅ MATCH FOUND: variant ${v.id}`);
      }
      
      return allMatch;
    });
    
    if (!match) {
      console.error('❌ PASO 5 FAILED: Variant not found');
      console.log('   Available combinations (first 5):');
      variants.slice(0, 5).forEach((v, i) => {
        console.log(`     ${i + 1}. option1="${v.option1}" option2="${v.option2}" option3="${v.option3}"`);
      });
      return;
    }
    
    console.log('✅ PASO 5: Variant match found');
    console.log('   Match ID:', match.id);
    console.log('   Match price:', match.price);
    console.log('   Match available:', match.available);
    
    // PASO 5.5: VALIDAR DISPONIBILIDAD
    if (!match.available) {
      console.error('❌ PASO 5.5: Variant not available!');
      alert(`Esta combinación no está disponible en stock. Por favor elige otra opción.`);
      
      // Revertir el cambio en el dropdown/select
      const slotPreview = this.el.querySelector(`[data-bundle-v5-preview="${slot}"]`);
      const container = slotPreview?.querySelector(`[data-dropdown-v5="${slot}-${optionName}"]`) || 
                       slotPreview?.querySelector(`[data-select-v5="${slot}-${optionName}"]`);
      if (container) {
        if (container.tagName === 'SELECT') {
          container.value = oldProduct.variants[optionName];
        } else {
          // Es dropdown, buscar y actualizar
          const dropdown = this.dropdowns.find(d => d.container === container);
          if (dropdown) {
            dropdown.select(oldProduct.variants[optionName]);
          }
        }
      }
      
      return;
    }
    console.log('✅ PASO 5.5: Variant is available');
    
    // PASO 6: Actualizar producto
    product.variantId = match.id;
    product.price = match.price;
    console.log('✅ PASO 6: Product updated with new variant');
    console.log('   Product variantId:', product.variantId);
    console.log('   Product price:', product.price);
    
    // PASO 7: Guardar en Map - FORZAR SOBRESCRITURA
    this.products.delete(slot); // Eliminar primero
    this.products.set(slot, product); // Agregar de nuevo
    console.log('✅ PASO 7: Saved to Map (delete + set)');
    
    // PASO 8: Verificar que se guardó
    const verification = this.products.get(slot);
    if (!verification) {
      console.error('❌ PASO 8 FAILED: Product not in Map after save!');
      return;
    }
    console.log('✅ PASO 8: Verification passed');
    console.log('   Verified variantId:', verification.variantId);
    console.log('   Verified price:', verification.price);
    console.log('   Verified variants:', verification.variants);
    
    // PASO 9: Actualizar precio en DOM
    const priceEl = this.el.querySelector(`[data-price-v5="${slot}"]`);
    if (priceEl) {
      priceEl.textContent = this.money(match.price);
      console.log('✅ PASO 9: Price updated in DOM');
    } else {
      console.warn('⚠️ PASO 9: Price element not found');
    }
    
    // PASO 10: Actualizar UI
    this.updateUI();
    console.log('✅ PASO 10: UI updated');
    
    console.log(`═══════════════════════════════════════`);
    console.log(`✅ UPDATE VARIANT - COMPLETADO`);
    console.log(`   Final variantId in Map: ${this.products.get(slot)?.variantId}`);
    console.log(`   Final variants in Map:`, this.products.get(slot)?.variants);
    console.log(`═══════════════════════════════════════\n`);
  }
  
  updateUI() {
    const count = this.products.size;
    this.els.count.textContent = `${count}/${this.config.slots}`;
    
    // Summary
    if (count > 0) {
      this.els.summary.style.display = 'block';
      const items = Array.from(this.products.values()).map(p => `• ${p.title}`).join('<br>');
      this.els.summaryList.innerHTML = items;
      
      // Calcular precio total de productos (sin descuento)
      const originalTotal = Array.from(this.products.values()).reduce((sum, p) => sum + p.price, 0);
      
      // Precio final (con descuento si hay precio fijo)
      const finalPrice = this.config.fixedPrice || originalTotal;
      
      // Mostrar precio original tachado si hay descuento
      const originalPriceEl = this.el.querySelector('[data-bundle-v5-original-total]');
      if (originalPriceEl && this.config.fixedPrice && originalTotal > this.config.fixedPrice) {
        originalPriceEl.textContent = this.money(originalTotal);
        originalPriceEl.style.display = 'block';
      } else if (originalPriceEl) {
        originalPriceEl.style.display = 'none';
      }
      
      // Mostrar precio final
      this.els.finalPrice.textContent = this.money(finalPrice);
    } else {
      this.els.summary.style.display = 'none';
    }
    
    // Botón
    if (count === this.config.slots) {
      this.els.addBtn.style.display = 'flex';
      this.els.addBtn.disabled = false;
    } else {
      this.els.addBtn.style.display = 'none';
    }
  }
  
  addToCart() {
    console.log('\n═══════════════════════════════════════════════════');
    console.log('🛒 ADD TO CART - INICIO');
    console.log('═══════════════════════════════════════════════════');
    
    // DEBUG: Imprimir TODO el estado actual
    console.log('\n🔍 DEBUG - ESTADO COMPLETO DEL BUNDLE:');
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    
    this.products.forEach((p, slot) => {
      console.log(`\n📍 SLOT ${slot}:`);
      console.log(`   Product ID: ${p.id}`);
      console.log(`   Title: ${p.title}`);
      console.log(`   Variants object:`, JSON.stringify(p.variants, null, 2));
      console.log(`   Variant ID que se enviará: ${p.variantId}`);
      console.log(`   Price: ${p.price}`);
      
      // Verificar qué variant corresponde a este ID
      const variants = this.variants.get(p.id);
      if (variants) {
        const matchedVariant = variants.find(v => v.id.toString() === p.variantId.toString());
        if (matchedVariant) {
          console.log(`   ✅ Variant encontrado en Shopify:`);
          console.log(`      option1: ${matchedVariant.option1}`);
          console.log(`      option2: ${matchedVariant.option2}`);
          console.log(`      option3: ${matchedVariant.option3}`);
          
          // CRÍTICO: Verificar que las opciones coincidan
          const optionNames = Object.keys(p.variants);
          const optionMapping = {};
          
          optionNames.forEach(name => {
            const value = p.variants[name];
            for (let i = 1; i <= 3; i++) {
              if (variants.some(v => v[`option${i}`] === value)) {
                if (!Object.values(optionMapping).includes(i)) {
                  optionMapping[name] = i;
                  break;
                }
              }
            }
          });
          
          // Verificar que TODAS las opciones coincidan
          const allMatch = Object.entries(p.variants).every(([name, value]) => {
            const optIndex = optionMapping[name];
            const matches = matchedVariant[`option${optIndex}`] === value;
            if (!matches) {
              console.error(`   ❌ MISMATCH: ${name} esperado="${value}" pero variant tiene="${matchedVariant[`option${optIndex}`]}"`);
            }
            return matches;
          });
          
          if (!allMatch) {
            console.error(`   ❌ ¡VARIANT ID NO COINCIDE CON LAS OPCIONES!`);
            console.error(`   Esto causará que se envíe la variante incorrecta al carrito`);
            alert(`Error: El producto "${p.title}" en slot ${slot} tiene un variant ID incorrecto. Por favor vuelve a seleccionarlo.`);
            return;
          }
        } else {
          console.error(`   ❌ Variant ID ${p.variantId} NO EXISTE en Shopify!`);
        }
      }
    });
    
    console.log('\n━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    console.log('POR FAVOR COPIA TODO LO DE ARRIBA Y COMPÁRTELO');
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n');
    
    // VERIFICACIÓN 1: Número de productos
    if (this.products.size !== this.config.slots) {
      console.error(`❌ Expected ${this.config.slots} products, got ${this.products.size}`);
      alert(`Por favor completa los ${this.config.slots} productos del combo`);
      return;
    }
    console.log(`✅ VERIFICACIÓN 1: ${this.products.size} products in bundle`);
    
    // VERIFICACIÓN 2: Contenido del Map
    console.log('\n📦 PRODUCTOS EN MAP:');
    const items = [];
    
    this.products.forEach((p, slot) => {
      console.log(`\n  Slot ${slot}:`);
      console.log(`    ID: ${p.id}`);
      console.log(`    Title: ${p.title}`);
      console.log(`    Variants:`, p.variants);
      console.log(`    VariantId: ${p.variantId}`);
      console.log(`    Price: ${p.price}`);
      
      // VERIFICACIÓN 3: VariantId existe
      if (!p.variantId) {
        console.error(`    ❌ MISSING VARIANT ID!`);
        alert(`Error: Producto en slot ${slot} no tiene variantId`);
        return;
      }
      
      // VERIFICACIÓN 4: Variant es válido (existe en variants data)
      const variants = this.variants.get(p.id);
      if (variants) {
        const exists = variants.find(v => v.id.toString() === p.variantId.toString());
        if (!exists) {
          console.error(`    ❌ VARIANT ${p.variantId} NOT IN VARIANTS DATA!`);
          alert(`Error: VariantId ${p.variantId} no es válido para este producto`);
          return;
        }
        console.log(`    ✅ Variant validated`);
      }
      
      items.push({
        id: p.variantId,
        quantity: 1,
        properties: {
          '_combo': 'true',
          '_combo_price': this.config.fixedPrice,
          '_slot': slot,
          '_variants': JSON.stringify(p.variants)
        }
      });
    });
    
    // VERIFICACIÓN 5: Items preparados
    if (items.length !== this.config.slots) {
      console.error(`❌ Expected ${this.config.slots} items, prepared ${items.length}`);
      alert('Error al preparar los productos');
      return;
    }
    console.log(`\n✅ VERIFICACIÓN 5: ${items.length} items prepared`);
    
    // VERIFICACIÓN 6: Mostrar items a enviar
    console.log('\n📦 ITEMS A ENVIAR AL CARRITO:');
    items.forEach((item, idx) => {
      console.log(`  ${idx + 1}. VariantId: ${item.id}`);
      console.log(`     Properties:`, item.properties);
    });
    
    console.log('\n🚀 ENVIANDO AL CARRITO...');
    console.log('═══════════════════════════════════════════════════\n');
    
    this.els.addBtn.disabled = true;
    this.els.addBtn.textContent = 'Agregando...';
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(r => {
      console.log('📥 Response status:', r.status);
      return r.json();
    })
    .then(data => {
      console.log('✅ RESPUESTA DEL CARRITO:');
      console.log(data);
      console.log('\n🎉 SUCCESS! Redirecting to cart...\n');
      
      setTimeout(() => {
        window.location.href = '/cart';
      }, 500);
    })
    .catch(err => {
      console.error('❌ ERROR EN FETCH:');
      console.error(err);
      alert('Error al agregar al carrito. Revisa la consola.');
      this.els.addBtn.disabled = false;
      this.els.addBtn.textContent = 'Agregar combo al carrito';
    });
  }
  
  money(cents) {
    return new Intl.NumberFormat('es-PE', {
      style: 'currency',
      currency: 'PEN'
    }).format(cents / 100);
  }
}

// ============================================
// INIT
// ============================================

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-bundle-v5]').forEach(el => {
    new BundleV5(el);
  });
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-bundle-v5]').forEach(el => {
      new BundleV5(el);
    });
  });
}